import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import api from "@/lib/api";
import { ArrowUpRight } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const [featured, ...rest] = posts;

  return (
    <>
      <Seo title="Blog & Actualités" description="Conseils, tendances et coulisses de l'événementiel B2B par les experts de Désir Events." path="/blog" />
      <PageHero eyebrow="Le Journal" title={<>Idées & <span className="italic text-lime-dim">coulisses</span></>} subtitle="Nos analyses et conseils pour concevoir des événements d'entreprise qui font la différence." />

      <section className="mx-auto max-w-[1440px] px-5 py-16 md:px-10 md:py-24">
        {loading ? (
          <p className="text-ink/40">Chargement…</p>
        ) : posts.length === 0 ? (
          <p className="text-ink/40">Aucun article pour le moment.</p>
        ) : (
          <>
            {featured && (
              <Reveal>
                <Link to={`/blog/${featured.slug}`} className="group grid overflow-hidden rounded-2xl border border-ink/10 bg-white md:grid-cols-2" data-testid="featured-post">
                  <div className="aspect-video overflow-hidden md:aspect-auto">
                    <img src={featured.cover_image} alt={featured.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  </div>
                  <div className="flex flex-col justify-center p-8 md:p-12">
                    <span className="text-[11px] uppercase tracking-[0.2em] text-lime-dim">{featured.category}</span>
                    <h2 className="mt-4 font-serif text-4xl font-medium leading-tight text-ink group-hover:text-lime-dim md:text-5xl">{featured.title}</h2>
                    <p className="mt-4 text-ink/60">{featured.excerpt}</p>
                    <span className="mt-6 flex items-center gap-2 text-sm text-ink/70 group-hover:text-lime-dim">Lire l'article <ArrowUpRight size={16} /></span>
                  </div>
                </Link>
              </Reveal>
            )}

            <div className="mt-6 grid gap-6 md:grid-cols-3">
              {rest.map((p, i) => (
                <Reveal key={p.id} delay={i % 3}>
                  <Link to={`/blog/${p.slug}`} className="group flex h-full flex-col overflow-hidden rounded-2xl border border-ink/10 bg-white transition-all duration-500 hover:-translate-y-1 hover:shadow-lg hover:shadow-ink/5" data-testid={`post-${p.slug}`}>
                    <div className="aspect-[16/10] overflow-hidden">
                      <img src={p.cover_image} alt={p.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    </div>
                    <div className="flex flex-1 flex-col p-6">
                      <span className="text-[11px] uppercase tracking-[0.2em] text-lime-dim">{p.category}</span>
                      <h3 className="mt-3 font-serif text-2xl font-medium text-ink group-hover:text-lime-dim">{p.title}</h3>
                      <p className="mt-3 flex-1 text-sm text-ink/55">{p.excerpt}</p>
                    </div>
                  </Link>
                </Reveal>
              ))}
            </div>
          </>
        )}
      </section>
    </>
  );
}
